import emitter from "@/emitter";
/*
  emitter is shared instance with vue app
  App.vue contains listener for 'appToast' event that
  creates toast using PrimeVue toast
  This allows toasts to be dispatched outside of vue components
*/

export default function appToast (toastParams) {
   return emitter.emit('appToast', {
    ...toastParams,
    group: 'app',
    life: toastParams.life || 2000
  });
}